export default __webpack_public_path__ + "static/media/charts.4404929f.png";